import { Auth } from '@aws-amplify/auth';
import { config } from '../amplify';

import { createClient, Client } from 'graphql-ws';
import { presignSigV4Url } from './awsSigV4';

const wsSubscriptionsServer = config.AppSync.websocketsEndpoint as string;

async function getSignedUrl(): Promise<string> {
  const AWS_REGION = config.AppSync.region;
  const SOCKET_HOST = wsSubscriptionsServer.replace('wss://', '').split('.')[0];
  const ENV = wsSubscriptionsServer.split('/').pop();
  const WEBSOCKET_URL = `${SOCKET_HOST}.execute-api.${AWS_REGION}.amazonaws.com`;

  // get clock drift
  const drift = await Auth.currentAuthenticatedUser({
    bypassCache: false,
  })
    .then((user) => user.signInUserSession.clockDrift * 1000)
    .catch(() => 0);

  // Get a signed URL (the signer puts the session token and the
  // drift-corrected date in the query string)
  return Auth.currentCredentials()
    .then(({ accessKeyId, secretAccessKey, sessionToken }) =>
      presignSigV4Url(
        `wss://${WEBSOCKET_URL}/${ENV}`,
        { accessKeyId, secretAccessKey, sessionToken },
        AWS_REGION,
        new Date(Date.now() - drift)
      )
    )
    .catch((e) => {
      console.warn(e);
      return `wss://${WEBSOCKET_URL}`;
    });
}

let wsClient: Client | null = null;

export function getWsClient(): Client {
  if (!wsClient) {
    wsClient = createClient({
      url: () => getSignedUrl(),
      lazy: true,
      retryAttempts: Infinity,
      shouldRetry: () => true,
      on: {
        error: (error) => {
          console.error('WS Error', error);
        },
      },
    });
  }
  return wsClient;
}

export function resetWsClient(): void {
  if (wsClient) {
    // Use terminate() instead of dispose() so the client reconnects with
    // fresh credentials (via the `url` factory) while the existing
    // GraphQLWsLink reference stays valid.
    wsClient.terminate();
  }
}
